export const ENDPOINTS = {
  getUploadUrl: "image-validator/get-upload-url",
  getSignedURL: "get-upload-url",
};
